import { isNil, range } from 'lodash';
import { cast, Instance, types as t } from 'mobx-state-tree';
import { KeyValueModelSnapshotIn } from '../../../question-data-model/key-value.store';
import { TFNAnswerQuestion } from '../../../question-data-model/Question/_implementations/tfn-answer-question.store';
import { TestQuestionStore } from '../test-question.store';

export const DoTestTFNQuestion = t
  .compose(TestQuestionStore, TFNAnswerQuestion)
  .named('DoTestTFNQuestion')
  .actions((self) => ({
    onAnswerQuestion(options: KeyValueModelSnapshotIn[]) {
      const [answer] = options;
      self.userAnswers = cast([answer.key]);
    },
    setQuestionProgress(question: string) {
      self.question = question;
    },
  }))
  .views(() => ({
    isAnswered(answer?: number) {
      return isNil(answer) === false;
    },
  }))
  .views((self) => ({
    get groupName() {
      return 'True / False / Not given';
    },

    get formattedQuestionNo() {
      return self.no;
    },

    get bottomBarQuestionNoes() {
      return range(self.maxSelectedOptions)
        .map((noIndex) => {
          const no = self.no + noIndex;
          return {
            no,
            answered: self.isAnswered(
              self.userAnswers.find((_u, userAnswerIndex) => userAnswerIndex === noIndex)
            ),
          };
        })
        .filter((item) => Boolean(item));
    },

    get questionCount() {
      return self.maxSelectedOptions;
    },

    get answerCount() {
      return (self?.userAnswers || []).filter((o) => self.isAnswered(o)).length;
    },

    prepareDataForSubmit() {
      return {
        questionId: self.uuid,
        question: self.question,
        type: self.type as any,
        userAnswers: self.userAnswers,
      };
    },
  }));

export interface DoTestTFNQuestionInstance extends Instance<typeof DoTestTFNQuestion> {}
